import React from "react";
import Radio from "antd/lib/radio";
import {
  SurveyQuestionCard,
  SymptomAlertCard,
  AnswerList,
  AnswerOption,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface PassingOutSectionProps {
  readonly currentPage: number;
}

export const PassingOutSection: React.FC<PassingOutSectionProps> = ({
  currentPage
}) => {
  return (
    <>
      {currentPage === 3 && (
        <SurveyQuestionCard
          sectionTag="PASSING OUT"
          title="Have you passed out or fainted on dialysis recently?"
          required
        >
          <FormItemStyle
            name="Have you passed out"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <Radio.Group
              value={localStorage.getItem("haveYouPassedOut")}
              onChange={e => {
                localStorage.setItem("haveYouPassedOut", e.target.value);
              }}
            >
              <AnswerList>
                <AnswerOption value="No">No</AnswerOption>
                <AnswerOption value="Yes">Yes</AnswerOption>
              </AnswerList>
            </Radio.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}
      {currentPage === 4 && (
        <SymptomAlertCard message="Please discuss your symptoms of passing out with your nurse or doctor" />
      )}
    </>
  );
};
